import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  Link,
  LinkIcon,
  // SocialButtons,
  GetStartedInput
} from '../../components'
import {Row, Col} from 'react-flexbox-grid'
import Styles from './Toolkit.css'
import container from '../../helpers/container'
// import ReactPlayer from 'react-player'
import {CopyToClipboard} from 'react-copy-to-clipboard';

@CSSModules(Styles, {allowMultiple:true})
export default class Toolkit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: 'Dear Plan Administrator,\nI am an employee of [Company Name], and I participate in our company 401(k) plan, which represents the bulk of my retirement savings. I am writing to inquire about adding socially responsible investment options that integrate gender lens investing to the plan.\nMany large pension funds already integrate gender lens criteria into their investing decisions. Integrating gender lens criteria to retirement investing can mean avoiding companies with poor gender balance at the executive level, or companies that neglect to offer basic policies promoting gender equality. It can also mean seeking out companies that are more equal and offer stronger policies. A growing body of evidence indicates that companies that are gender diverse and socially conscious end up performing better than those that are not.\nI believe it is my right to know what my retirement savings are invested in. Can you please tell me if our retirement plan offers any investment options that integrate gender lens investing criteria? If not, what steps should we take to add some to our plan?\nSocially responsible investing is no longer just an ethical issue. It is a key factor impacting financial well-being. New guidelines from the Department of Labor state that “environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment” and can be used when making decisions related to fiduciary duty.\nThere is an online tool, genderequalityfunds.org, which scores many commonly available mutual funds on gender equality criteria, and identifies funds that are socially responsible and invest in companies with equal gender balance and policies that promote gender equality. If none of our current plan options integrate gender lens and socially responsible investing, this tool could be used to find suitable mutual funds that could be included in our plan.\nThank you in advance for looking into this. I appreciate your time and look forward to hearing from you.\nBest,\n[Your Name]\n[Your contact information (company department, email, phone)]',
      copied: false,
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  onCopy = () => {
    this.setState({copied: true});
  };

  renderToolkitContent = (toolkitTitle, url) => {
    // const message = 'Action toolkit to move your money'

    return (
      <div styleName='toolkit'>
        <div styleName='toolkit-inner'>
          <div styleName='answer-title'>
            Step 1 – Talk to your colleagues and build a coalition
          </div>
          <div styleName='content-info'>
            <p>To effectively advocate for new offerings in your employer-sponsored plan, start by building a coalition of peers and interested co-workers inside your company. Your voice will be much stronger as a group. If you’re writing to someone in power, advocating on behalf of 10 or even 20 people carries a lot more weight than just one. One way to spur interest is to share the results of your Gender Equality Funds search with fellow employees. All plan participants are offered the same basket of mutual funds as you are, so they might be asking the same questions right now.</p>
            <p>Some companies have “corporate responsibility teams.” If there isn’t one already, it may be time to create one for gender equality investing. Communicate with your co-workers through a company intranet, employee portal, a company newsletter, corporate chats, or social media.</p>
          </div>
          <div styleName='answer-title-spaceabove'>
            Step 2 – Identify the best people to speak with
          </div>
          <div styleName='content-info'>
            <p>If you are a plan participant, you know or can easily find your 401(k)/403(b) plan administrator, manager, or coordinator. That’s where to start. There could also be a chief corporate responsibility officer or employee engagement manager, who also could be good resources. An effective method is to go to the LinkedIn pages of those people and find who might be sympathetic to this cause. Do any of them volunteer or have connections with organizations promoting women’s welfare? Look for indicators that they’re friendly to corporate responsibility and start contacting them in order of their friendliness. In a publicly listed company with more structure, a coalition is vital to signal to managers that it’s an important issue for many employees. If it’s a smaller company, you might be able to approach the CFO or CEO directly. In a mid-size or family company, a family member could be more influential.</p>
          </div>
          <blockquote>
            If your company has policies promoting gender diversity and equality, you can point out that there should be retirement plan options that align with those company values.
          </blockquote>
          <div styleName='answer-title-spaceabove'>
            Step 3 – Bring a solution to the table
          </div>
          <div styleName='content-info'>
            <p>The usual starting point in these conversations is: “We want to align our 401(k) fund choices with our company values. We want to invest in a more equal future. How can we enhance our 401(k) choices to do so?” </p>
            <p>Getting new fund choices added to the list of the existing plan options is a formal process, and could take up to a year. Larger companies often have some form of investment committee, which engages an investment advisor. Make sure you understand the timeline for making changes to your plan.</p>
            <p>If your company has policies promoting gender diversity and equality, you can point out that there should be retirement plan options that align with those company values. If your plan does not offer even a single socially responsible option, employees are not being allowed to align their investments with the company’s values.</p>
            <p>If the investment advisor and plan administrator refuse to help appropriate options, you may need to get fellow employees to sign a petition requesting the change and send it to the investment committee. If you are told, “But you’ll make less money if you apply gender lens investing,” you can say, “Actually, evidence shows gender diverse companies tend to have higher returns and lower risk. We want to be part of building a more equal future.” You can also check funds’ financial performance statistics.</p>
          </div>

          <div styleName='answer-title-spaceabove'>
            Sample letter to plan administrator
          </div>
          <div styleName='content-info'>
            <div styleName='letter-boxquote'>
              <p>Dear Plan Administrator,</p>

              <p>I am an employee of <strong>[Company Name]</strong>, and I participate in our company 401(k) plan, which represents the bulk of my retirement savings. I am writing to inquire about adding socially responsible investment options that integrate gender lens investing to the plan.</p>

              <p>Many large pension funds already integrate gender lens criteria into their investing decisions. Integrating gender lens criteria to retirement investing can mean avoiding companies with poor gender balance at the executive level, or companies that neglect to offer basic policies promoting gender equality. It can also mean seeking out companies that are more equal and offer stronger policies. A growing body of evidence indicates that companies that are gender diverse and socially conscious end up performing better than those that are not.</p>

              <p><strong>I believe it is my right to know what companies my retirement savings are invested in.</strong> Can you please tell me if our retirement plan offers any investment options that integrate gender lens investing criteria? If not, what steps should we take to add some to our plan?</p>

              <p>Socially responsible investing is no longer just an ethical issue. It is a key factor impacting financial well-being. New guidelines from the Department of Labor state that “environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment” and can be used when making decisions related to fiduciary duty.</p>

              <p>There is an online tool, GenderEqualityFunds.org, which scores many commonly available mutual funds on gender equality criteria, and identifies funds that are socially responsible and invest in companies with equal gender balance and policies that promote gender equality. <strong>If none of our current plan options integrate gender lens and socially responsible investing, this tool could be used to find suitable mutual funds that could be included in our plan.</strong></p>

              <p>Thank you in advance for looking into this. I appreciate your time and look forward to hearing from you.</p>
              <p>Best,</p>
              <p><strong>[Your Name]</strong></p>
              <p><strong>[Your contact information (company department, email, phone)]</strong></p>
            </div>

            <CopyToClipboard
              onCopy={this.onCopy}
              text={this.state.value}>
              <button
                styleName='letter-boxquote-copy-button'>
                {
                  this.state.copied
                  ? 'Copied'
                  : 'Copy to clipboard'
                }
                <LinkIcon
                  faclass={ this.state.copied
                            ? 'fa-check-square'
                            : 'fa-files-o' }
                />
              </button>
            </CopyToClipboard>

          </div>

          <div styleName='title'>
            Resources for gender-lens investing
          </div>
          <div styleName='lede'>
            Here are resources that can help you get started on your gender-lens investing journey
          </div>

          <Row styleName='resource-row'>
            <Col xs={12} sm={12} md={6} styleName='resource-col'>
              <div styleName='resource-headline'>
                Equileap
              </div>
              <div styleName='resource-info'>
                Equileap provides research and publications aimed at increasing gender awareness and supporting companies in their good practices. They also track other research indicating the connection between gender lens investing and financial returns.
              </div>
              <div styleName='resource-headline'>
                <Link
                  to={config.links.equileap}
                  title='Equileap'
                  xstrong={true}
                >
                  Learn more
                </Link>
              </div>
            </Col>
            { /* <Col xs={12} sm={12} md={4} styleName='resource-col'>
              <div styleName='resource-headline'>
                Equileap
              </div>
              <div styleName='resource-info'>
                Equileap provides research and publications aimed at increasing gender awareness and supporting companies in their good practices. They also track other research indicating the connection between gender lens investing and financial returns.
              </div>
              <div styleName='resource-headline'>
                <Link
                  to={config.links.equileap}
                  title='Equileap'
                  xstrong={true}
                >
                  Learn more
                </Link>
              </div>
            </Col> */ }
            <Col xs={12} sm={12} md={6} styleName='resource-col'>
              <div styleName='resource-headline'>
                Forum for Sustainable and<br/>Responsible Investment
              </div>
              <div styleName='resource-info'>
                US SIF: The Forum for Sustainable and Responsible Investment works to advance sustainable, responsible and impact investing. Learn the basics of responsible investing.
              </div>
              <div styleName='resource-headline'>
                <Link
                  to={config.links.ussif}
                  title='The Forum for Sustainable and Responsible Investment'
                  xstrong={true}
                >
                  Learn more
                </Link>
              </div>
            </Col>
          </Row>


          { /* <SocialButtons message={message} link={url}/> */ }

        </div>
      </div>
    )
  }

  render() {
    const title = 'Gender-lens investing action toolkit'
    const description = 'Use the Gender Equality Funds action toolkit to make a change and move your money.'
    const url = config.domain + config.routes.toolkit

    const bannerImage = 'green'
    const bannerHeadline = 'Gender-lens investing action toolkit'
    const bannerSubtitle = 'Action toolkit to move your money'

    return (
      <div>
        {container.helmet(title, description, url)}

        <div styleName='image-banner'>
          <div styleName='image-banner-container'>
            <div styleName='image-banner-container-inner'>
              <div styleName={'image-banner-'+bannerImage}>
                <div styleName='image-banner-headline'>{bannerHeadline}</div>
                <div styleName='image-banner-subtitle'>{bannerSubtitle}</div>
              </div>
            </div>
          </div>
        </div>

        <div styleName='toolkit'>
          <div styleName='toolkit-inner'>
            <div styleName='title'>
              Education and resources
            </div>
            <div styleName='lede'>
              Learn how to make a change and invest in gender equality.
            </div>
          </div>
        </div>


        <div styleName='x-401k-container'>
          <div styleName='x-401k-container-inner'>
            <div styleName='x-401k-info-photo'>
              <div
                styleName='x-401k-photo'
                title='401k retirement plans'
              />
              <div styleName='x-401k-info'>
                <div styleName='x-401k-info-title'>
                  If you’re an individual investor
                </div>
                <p>
                  It’s your money, and your financial advisor works for you. You just need to have a meeting to discuss what you have learned about your investments and how you would like them changed to align with your values. An investment professional will advise you of potential risk and you can make your own decisions.
                </p>

              </div>
            </div>
            <p>
              You can trade your own portfolio, or tell your manager to do it. They may push back and tell you that you’ll make less money. You can reply, “Maybe, but it’s my money, and evidence shows gender diverse companies tend to have higher returns and lower risk.” You can also check the mutual fund financial performance statistics on each fund’s page. It’s a financial advisors job to manage your money, so you should drive home the point in no uncertain terms.
            </p>
            <p>
              Ask for help finding the best choices. The advisor may say no if you tell them to invest in a specific fund because it has a short or rocky history, so you may need to be patient as they find a better alternative. If they’re being lazy or unwilling to help you with this transition, find a new advisor. If your broker is tied to a big-name brand, they may only be able to offer products that the particular company has approved. If you want innovation, you might need a new advisor.
            </p>
          </div>
        </div>

        <div styleName='x-ays-container'>
          <div styleName='x-ays-container-inner'>
            <div styleName='x-ays-info-photo'>
              <div
                styleName='x-ays-photo'
                title='As You Sow'
              />
              <div styleName='x-ays-info'>
                <div styleName='x-ays-info-title'>
                  Adding options to your retirement plan
                </div>
                <p>
                  If your employer’s 401(k) plan already has options that meet your gender lens investing needs, that's great! But many plans only offer diversified funds that own the whole market, including the companies that score low on gender balance and policies promoting gender equality. It is possible to convince companies to add options to their retirement plan , but it will take more effort than if you have an IRA or a personal portfolio that you solely control. You will need to engage the plan administrator to help find the right blend of options to satisfy the many employees who all invest in the same basket of mutual funds. This may take time and possibly some coordination with your co-plan participants.
                </p>
              </div>
            </div>
            <blockquote>
              To effectively advocate for new offerings through your employer-sponsored plan, first build a coalition of peers and interested co-workers inside your company.
            </blockquote>
          </div>
        </div>

        { this.renderToolkitContent(title, url) }

        <GetStartedInput />

      </div>
    )
  }
}
